/** @format */

import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";

interface PlannerWidgetProps {
  updateHeight: (newHeight: number) => void;
  currHeight: number;
  setUpdatedheight: (updatedHeight: number) => void;
}

export const BLOCK_MIN_HEIGHT = 165;

const useStyles = makeStyles((theme) => ({
  splitter: {
    display: "flex",
    justifyContent: "center",
    cursor: "s-resize",
    userSelect: "none",
    marginTop: "-6px",
    width: "100%",
    position: "fixed",
    zIndex: 1296,
  },
  borderLine: {
    minHeight: "4px",
    maxHeight: "4px",
    backgroundColor: "#F4B827",
    width: "100%",
    position: "absolute",
    top: "6px",
  },
  dragHandle: {
    background: "#F4B827",
    borderRadius: "3px",
    width: "60px",
    height: "17px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  lightLine: {
    width: "40px",
    backgroundColor: "rgba(255, 255, 255, 0.45)",
    height: "1px",
  },
}));

function PaneSplitter({ updateHeight, currHeight,setUpdatedheight }: PlannerWidgetProps) {
  const classes = useStyles();
  const startPosition = React.useRef();

  const onDragSplitter = (e: any) => {
    const tempDelta = e.clientY - (startPosition.current || 0);
    let newH = currHeight + tempDelta;
    if (window && newH > window.innerHeight * 0.8) {
      newH = window.innerHeight * 0.8
    }
    
    updateHeight(newH > BLOCK_MIN_HEIGHT ? newH : BLOCK_MIN_HEIGHT);
    setUpdatedheight(newH > BLOCK_MIN_HEIGHT ? newH : BLOCK_MIN_HEIGHT);
  };

  const onDragStart = (e: any) => {
    e.preventDefault();
    if (window.getSelection) {
      window.getSelection()?.removeAllRanges();
    } else if ((document as any)?.selection) {
      (document as any)?.selection?.empty();
    }
    startPosition.current = e.clientY;
    document.onmousemove = onDragSplitter;
    document.onmouseup = () => {
      document.onmousemove = document.onmouseup = null;
    };
  };

  return (
    <div className={classes.splitter} onMouseDown={onDragStart} style={{ top: `${currHeight + 114}px` }}>
      <div className={classes.borderLine} />
      <div className={classes.dragHandle}>
        <div className={classes.lightLine} />
        <div className={classes.lightLine} />
      </div>
    </div>
  );
}

export default PaneSplitter;
